/** `image_url: width:` rejects anything above this (shopify.dev/docs/api/liquid/filters/image_url). */
const SHOPIFY_IMAGE_URL_MAX_WIDTH = 5760;

/**
 * Matches `{{ featured_image | img_url: '600x600' }}` / `{{ media.src | img_url: '1024x1024' }}`.
 * Bare `media` objects (video thumbnails) are left alone: they are not image objects.
 */
const ELSE_TAG = '{% else %}';

const IMG_URL_REGEX = /{{\s*(featured_image|[\w.[\]]+\.src)\s*\|\s*img_url:\s*(['"])(\d+)x\d*\2\s*}}/g;

/**
 * The deprecated Shopify `img_url` filter ignores the size for `.avif` files and always
 * returns the `_small` (100x100) variant. `image_url` resizes every format, so
 * convert the product image templates at export time (existing pages are fixed on republish).
 *   `{{ featured_image | img_url: '600x600' }}`
 *   -> `{% if featured_image != blank %}{{ featured_image | image_url: width: 600 }}{% else %}{{ featured_image | img_url: '600x600' }}{% endif %}`
 * Only the width is passed: with both width and height `image_url` crops the image (default `crop: center`).
 * Trade-off: `img_url: 'NxN'` fits the image in an NxN box, so a portrait image is now taller than N.
 * A blank input keeps `img_url`, which renders Shopify's "no image" placeholder instead of an error.
 * Idempotent: the `img_url` kept in the `{% else %}` fallback is not converted again.
 * @param template liquid template
 * @returns template using `image_url`
 */
export const convertImgUrlToImageUrl = (template: string): string => {
  if (!template) {
    return template;
  }

  return template.replace(IMG_URL_REGEX, (match, subject: string, _quote: string, width: string, offset: number) => {
    if (template.slice(Math.max(0, offset - ELSE_TAG.length), offset) === ELSE_TAG) {
      return match;
    }
    const imageWidth = Math.min(parseInt(width), SHOPIFY_IMAGE_URL_MAX_WIDTH);
    return `{% if ${subject} != blank %}{{ ${subject} | image_url: width: ${imageWidth} }}${ELSE_TAG}${match}{% endif %}`;
  });
};
